const lang = {
    // 侧边栏目录
    routeList: [
        {
            path: "/admin",
            title: "/root/auth",
            name: "Permission management",
            icon: "el-icon-user",
            catalogue: true,
            children: [
                {
                    path: "admin",
                    name: "admin list",
                    isShow: true,
                },
                {
                    path: "admin-detail",
                    name: "admin detail",
                    isShow: false,
                },
                {
                    path: "admin-auth-role",
                    name: "role list",
                    isShow: true,
                },
                {
                    path: "admin-auth-role-detail",
                    name: "role detail",
                    isShow: false,
                },
                {
                    path: "admin-auth-api",
                    name: "permission list",
                    isShow: true,
                },
                {
                    path: "admin-auth-api-detail",
                    name: "permission details",
                    isShow: false,
                },
                {
                    path: "admin-auth-category",
                    name: "permission category",
                    isShow: true,
                },
                {
                    path: "admin-auth-category-detail",
                    name: "permission classification",
                    isShow: false,
                },
            ],
        },
        {
            path: 'store-message',
            title: '/store',
            name: 'Store',
            icon: 'el-icon-shopping-bag-2',
            catalogue: true,
            children: [
                {
                    path: 'store-message',
                    name: 'Store List',
                    isShow: true,
                },
                {
                    path: 'add-store-info',
                    name: 'Add Store',
                    isShow: true,
                },

            ]


        },
        {
            path: 'scratch-code',
            title: '/scratch',
            name: 'Scratch code',
            icon: 'el-icon-s-grid',
            catalogue: true,
            children: [
                {
                    path: 'scratch-code',
                    name: 'View scratch code list',
                    isShow: true,
                },
                {
                    path: 'add-scratch-code',
                    name: 'Add scratch code',
                    isShow: true,
                },
                {
                    path: 'check-scratch-code',
                    name: 'Verify scratch code',
                    isShow: true,
                },
                {
                    path: 'scratch-check-log',
                    name: 'View a list of write-off records',
                    isShow: true,
                },


            ]


        }
    ],
    commonStatusList: [
        {
            id: 0,
            name: "All",
            tag: "",
        },
        {
            id: 1,
            name: "Published ",
            tag: "success",
        },
        {
            id: 2,
            name: "Under review",
            tag: "warning",
        },
        {
            id: 3,
            name: "Invalid",
            tag: "danger",
        },
    ],
    statusSelectList: [
        {
            id: 1,
            name: "Published",
            tag: "success",
        },
        {
            id: 2,
            name: "Under review",
            tag: "warning",
        },
        {
            id: 3,
            name: "Invalid",
            tag: "danger",
        },
    ],
    // 权限管理
    admin: {
        name: 'name',
        remark: 'Remark',
        email: 'Mailbox',
        refreshAuth: '刷新权限',
        updatePermissions: '用户权限同步成功',
        accountDetail: '管理员账号详情',
        searchUser: '搜索用户',
        userId: '用户ID',
        username: 'Account number',
        password: 'Password',
        role: 'Role',
        onlySearch: '暂不支持修改用户ID,如需修改请先进行新增',
        rulesEmailTip: '请输入邮箱',
        rulesValid: '长度大于 3 个字符',
        rulesNameTip: '请输入名称',
        rulesPasswordTip: '请输入密码',
        rulesPasswordValid: '长度大于 6 个字符',
    },
    api: {
        name: 'name',
        identifier: 'API',
        apiDetail: '接口分类详情',
        method: '请求方式',
    },
    category: {
        name: '分类名称',
        identifier: '分类路径',
        detail: '接口分类详情'
    },
    role: {
        name: '角色名称',
        detail: '角色详情',
        onlyRead: '只读'
    },
    // 登录页
    login: {
        BackgroundManagementSystem: 'SMART SHOP ADMIN MANAGEMENT SYSTEM',
        Account: 'Account',
        Password: 'Password',
        Login: 'Login',
        RegisteredAccount: 'Registered account',
        ForgetPassword: 'Forget password',
        CurrentVersion: 'Current version',
        EnterAccount: '',
        EnterPassword: '',
        LogErr: 'There was an error logging in：',
        EnterCorrectPwdInfo: 'Please enter the correct password information',
        EnterCorrectAccountInfo: "Please enter the correct account information"
    },
    // 注册账号
    registerAccount: {
        BackgroundManagementSystem: 'SMART SHOP ADMIN MANAGEMENT SYSTEM',
        RegisteredAccount: 'Registered account',
        UserName: 'UserName',
        Email: 'Email：',
        VerificationCode: 'Verification code',
        Password: 'Password：',
        EnterName: '',
        EnterEmail: '',
        EnterVal: '',
        GetVerificationCode: 'Get the verification code',
        EnterPassword: '',
        Register: 'Register',
        ReturnHomePage: 'Back home page',
        EnterPassword: 'Please input a password',
        EnterCorrentEmail: 'Please enter the correct mailbox first',
        getVerCodeSuccess: 'Verification code obtained successfully',
        getVerCodeFail: 'Error in obtaining verification code：',
        userNameEmpty: 'User name cannot be empty',
        emailEmpty: 'Please enter the correct mailbox first',
        codeVerEmpty: 'Please enter the correct verification code first',
        pwdEmpty: 'Password cannot be empty',
    },
    // 忘记密码
    changePassword: {
        BackgroundManagementSystem: 'SMART SHOP ADMIN MANAGEMENT SYSTEM',
        ResetPassword: 'Reset Password',
        Email: 'Email：',
        VerificationCode: 'Verification code：',
        GetVerificationCode: 'Get the verification code',
        NewPassword: 'New password',
        EnterNewPassword: '',
        ReturnHomePage: 'Back home page',
        EnterEmail: '',
        EnterVal: '',
        EnterCorrentEmail: 'Please enter the correct mailbox first',
        getVerCodeSuccess: 'Verification code obtained successfully',
        getVerCodeFail: 'Error in obtaining verification code：',
        emailEmpty: 'Please enter the correct mailbox first',
        codeVerEmpty: 'Please enter the correct verification code first',
        EnterNewPwd: 'Please enter a new password',
        ResetSuccess: 'Password reset successfully',
        ResetPwdErr: 'An error occurred with the password reset：'

    },
    status: 'Status',
    statusMsg: 'Please select',
    key: 'Keyword ',
    keyMsg: 'Please enter keyword',
    filter: 'Filter',
    add: 'Add',
    edit: 'Edit',
    delete: 'Remove',
    save: 'Save',
    back: 'Return',
    operate: 'Operate',
    weight: 'Weight',
    classify: 'Classification ',
    resourceSelect: 'Resource selection',
    pcIcon: 'PC side icon',
    wapIcon: 'WAP-side icon',
    errorMsg: 'Failed to get data',
    cancelDelete: 'CancelDelete ',
    confirm: {
        title: 'This action will permanently delete this data, do you want to continue?',
        tip: 'Tip',
        determine: 'Determine',
        cancel: 'Cancel'
    },
    successfullyDeleted: 'Deleted successfully !',
    successfullyAdded: 'Added successfully !',
    successfullyModified: 'Successfully added !',
    checkForm: 'Please check the form!',
    all: 'All',
    copy: {
        copy: '复制',
        paste: '粘贴',
        copySuccessful: '复制成功',
        copyFailed: '复制失败',
        inconformityContent: '粘贴板的内容不符合当前列表信息',
    },
    // 公共部分
    commonInfo: {
        classify: 'Classification',
        add: 'Add',
        filter: 'Filter',
        Store: 'Store',
        UpdateInfo: 'Update personal information',
        ChangePassword: 'Change password',
        AboutSystem: 'About system',
        LogOut: 'Log out',
        ClearCache: 'Clear cache',
        StoreList: 'Store List',
        AddStore: 'Add Store',
        Back: 'Back',
        DeleteItemWarning: 'This operation will permanently delete the data, do you want to continue？',
        Confirm: 'Confirm',
        Cancel: 'Cancel',
        ImportSucceeded: 'Import succeeded',
        UpdateSucceed: 'Update succeed',
        DeleteSucceed: 'Delete succeed',
        CancelDelete: 'Cancel delete',
        AddStoreSucceed: 'Add Store Succeed',
        Tips: 'Tips',
        ChangeLanguage: 'Are you sure to switch languages?',
        ModifyData: 'Modify data',
        nickName: 'Nickname',
        headPortrait: 'Head portrait',
        Loading: 'Loading',
        // 警告部分
        EnterInformation: 'Enter the information',

        logOutConfirm: "It 's going to exit the system, do you want to continue?",
        OldPassword: 'Old Password',
        NewPassword: 'New Password',
        Save: 'Save',
        OldPasswordEmptyWarning: 'Old password cannot be empty',
        NewPasswordEmptyWarning: 'New password cannot be empty',
        OldNewSameWarning: 'Please do not set a new password that is the same as the old password',
        PasswordModifySuccess: 'Password modified successfully',
        About: 'About',
        BackgroundManagementSystem: 'SMART SHOP ADMIN MANAGEMENT SYSTEM',
        AboutSystem: 'About System',
        Version: 'Version：',
        // 刮刮码
        ScratchCode: 'Scratch code',
        CodeList: 'View scratch code list',
        addScratchCode: 'Add scratch code',
        scratchCheckLog: 'View a list of write-off records',
        checkScratchCode: 'Verify scratch code',
        viewDetail: 'details',
        addSucceed: 'Added Successfully',
        status: 'Status',
        pleaseSelect: 'Please select',
        keyWord: 'Keyword',
        pleaseEnterKey: 'Please enter a keyword',
        beginTime: 'Start time:',
        pleaseSelectBeginTime: 'Please select the start time',
        endTime: 'End time:',
        pleaseSelectEndTime: 'Please select the end time',
        success: 'success',
        accountNoPermission: 'Account has no permission',
    },

    //    查看门店
    storeMessage: {
        // label部分
        Country: 'Country',
        Province: 'Province/State',
        City: 'City',
        CompanyName: 'Company Name',
        TypeOfRetailArea: 'Type of Retail Area',
        newest: 'Newest',
        Oldest: 'Oldest',
        area: "Estimate Outlet's Space (in sq.ft.)",
        SellOutMoney: 'Average Monthly Sell Out',
        SMOKSellOutMoney: 'Average Monthly Smok Sell Out',
        StoreLevel: 'Company Level',
        // 下拉框部分
        SelectCountry: 'Please Select A country',
        SelectProvince: 'Please Select A province',
        SelectCity: 'Please Select A City',
        SelectCompanyName: 'Please Enter The Company Name',
        SelectRetailArea: 'Please Select The Retail Area',
        SelectCompanyArea: 'Please Select The Company Area',
        SelectMonthlySellOut: 'Please Select Average Monthly Sell Out',
        SelectMonthlySmokSellOut: 'Please Select Average Monthly Smok Sell Out',
        SelectCompanyLevel: 'Please Select Company Level',
        Search: 'Search',
        DownloadTheFile: 'Download the file',
        UpdateScore: 'Update score',
        Score: 'Score',
        Operation: 'Operation',
        Edit: 'Edit',
        Delete: 'Delete',
        UploadFiles: 'Upload Files'
    },
    // 添加门店
    addStore: {
        AddStore: 'Add Store',
        Country: 'Country',
        Province: 'Province/State',
        City: 'City',
        TypeOfRetailArea: 'Type of Retail Area',
        CompanyName: 'Company Name',
        area: "Estimate Outlet's Space (in sq.ft.)",
        SellOutMoney: 'Average Monthly Sell Out',
        SMOKSellOutMoney: 'Average Monthly Smok Sell Out',
        ContactInformation: "Contact Information",
        StoreAddress: 'Store address',
        StoreZipCode: 'Store zip code',
        AddNow: 'Add now',
        Added: 'Added',
        // 警告部分
        EnterInformation: 'Enter the information'
    },
    // 联系方式
    contactMethods: {
        Position: "Position",
        Name: 'Name',
        Tel: 'Tel',
        Email: 'Email',
        Delete: 'Delete',
        Add: 'Add',
        Cancel: "Cancel",
        Confirm: 'Confirm',
        Edit: 'Edit'
    },
    // 编辑门店
    editStoreDetail: {
        EditDetails: 'Edit Details',
        Country: 'Country',
        Province: 'Province/State',
        City: 'City',
        TypeOfRetailArea: 'Type of Retail Area',
        CompanyName: 'Company Name',
        area: "Estimate Outlet's Space (in sq.ft.)",
        SellOutMoney: 'Average Monthly Sell Out',
        SMOKSellOutMoney: 'Average Monthly Smok Sell Out',
        EditContactInformation: "Contact Information",
        StoreAddress: 'Store address',
        StoreZipCode: 'Store zip code',
        Number: 'Number',
        OutletStatus: 'Outlet Status',
        Picture: 'Picture',
        ImageLink: 'Image link',
        Score: 'Score',
        DateDate: 'Data Date',
        Save: 'Save',
        EditSuccess: 'Edit Success'
    },
    // 刮刮码
    scratchCode: {
        addScratchCode: 'Add scratch code',
        count: 'count',
        editScratchCodeDetail: 'Scraper code details',
        editScratchCheckCodeDetail: 'Write off code record details',
        checkScratch: 'Write off',
        addScratchSucceed: 'Successfully added scratch code',
        uploadCheck: 'Upload File Verification',
        checkTime: 'Number of checks',
        scratchCode: 'Scratch code',
        pleaseEnterScratchCode: 'Please enter scratch code',
        scratchCodeExample: '（ If multiple inputs are entered, they need to be separated by spaces, such as 12345678 23456789 ）',
        manualCheck: 'Manual cancellation',
        succeedTime: 'Number of successes',
        failedTime: 'Number of errors',
        repeatTime: 'Number of repetitions',
        currentSucceedTime: 'Successful write off',
        failedNumber: 'Error number',
        repeatedCheck: 'Repeated write off',
        individual: '',

    }
}
export default lang;